// Lenient on purpose (used for dropped files): some browsers report an empty
// or unusual type for real audio files, e.g. .ogg as "application/ogg", so
// only files that are clearly not audio are turned away.
const AUDIO_EXTENSIONS = ["mp3", "wav", "m4a", "mp4", "aac", "ogg", "oga", "opus", "flac", "webm", "aif", "aiff", "wma"];

export const extensionOf = (name: string) => name.split(".").pop()?.toLowerCase() ?? "";

export const isAudioFile = (file: File) =>
  file.type === "" || file.type.startsWith("audio/") || AUDIO_EXTENSIONS.includes(extensionOf(file.name));

export const isPdfFile = (file: File) => file.type === "application/pdf" || extensionOf(file.name) === "pdf";
